import { useSelector } from "react-redux";
import { TextField, InputAdornment } from "@mui/material";
import { useLocation } from "react-router";

import { RootState } from "@/store/store";
import CalendarComponent from "../Calendar/Calendar";
import { inputStyles } from "@/utils/constants";
import { IconCalendar } from "./IconCalendar";

import { IInputCalendarProps } from "@/shared/interfaces/ui";

import "./InputFieldCalendar.scss";

export default function InputFieldCalendar({ text }: IInputCalendarProps) {
    const location = useLocation();
    const isAppointments = location.pathname.includes("appointments");

    const isVisibleCalendarInSheduleHeader = useSelector(
        (state: RootState) => state.ui.isVisibleCalendarInSheduleHeader,
    );
    const globalDate = useSelector(
        (state: RootState) => state.schedule.globalDate,
    );
    const patientsBirthDay = useSelector(
        (state: RootState) => state.patients.patientsBirthDay,
    );

    return (
        <div>
            <TextField
                type='date'
                value={
                    (text === "Дата народження" ? patientsBirthDay : globalDate)
                        .toString()
                        .split("T")[0]
                }
                id='outlined-error-helper-text'
                label={text}
                variant='outlined'
                sx={{
                    ...inputStyles.root,
                    width: "100%",
                    marginBottom: "16px",
                    "MuiInputBase-root": { borderRadius: "6px !important" },

                    "& input::-webkit-calendar-picker-indicator": {
                        display: "none",
                    },
                }}
                slotProps={{
                    input: {
                        endAdornment: (
                            <InputAdornment position='end'>
                                <IconCalendar />
                            </InputAdornment>
                        ),
                        className: isVisibleCalendarInSheduleHeader
                            ? "Mui-focused"
                            : "",
                    },
                }}
            />
            <CalendarComponent text={text} />
        </div>
    );
}
